import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a2ca885"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Nenhum material")
const _hoisted_3 = { class: "row q-gutter-sm" }
const _hoisted_4 = { class: "text-justify" }
const _hoisted_5 = {
  key: 1,
  class: "q-pa-md flex flex-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle1" }, "Nenhum material encontrado", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, {
    "header-class": ["q-pa-sm"],
    group: "topics",
    modelValue: _ctx.expandedItem,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandedItem) = $event))
  }, {
    header: _withCtx(() => [
      _createVNode(_component_q_item_section, { class: "q-pa-sm" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.topic.title), 1)
            ]),
            _: 1
          }),
          (_ctx.topic.materials.length)
            ? (_openBlock(), _createBlock(_component_q_item_label, {
                key: 0,
                caption: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.topic.materials.length > 1 ? `${_ctx.topic.materials.length} Materiais` : '1 Material'), 1),
                  (_ctx.totalStudied())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "/ " + _toDisplayString(_ctx.totalStudied() > 1 ? `${_ctx.totalStudied()} Estudados` : '1 Estudado'), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_q_item_label, {
                key: 1,
                caption: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      (_ctx.topic.materials.length > 1)
        ? (_openBlock(), _createBlock(_component_q_item_section, {
            key: 0,
            side: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topic.materials.length, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["dot", i + 1 <= _ctx.totalStudied() ? "bg-green" : null]),
                    key: i,
                    style: _normalizeStyle({ background: _ctx.$q.dark.isActive ? "rgba(255,255,255,.2)" : "rgba(0,0,0,0.2)" })
                  }, null, 6))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "no-padding" }, {
            default: _withCtx(() => [
              (_ctx.topic.materials && _ctx.topic.materials.length)
                ? (_openBlock(), _createBlock(_component_q_list, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topic.materials, (material, m) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                          class: _normalizeClass(["q-pa-md", [material._id === _ctx.selected && "bg-green"]]),
                          "data-cy": "topic-item",
                          onClick: ($event: any) => (_ctx.openMaterialPreview(material)),
                          clickable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { side: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  color: material._id === _ctx.selected ? "white" : material.history && material.history.studied && "green",
                                  name: material.history && material.history.studied ? "check_box" : "check_box_outline_blank"
                                }, null, 8, ["color", "name"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_label, {
                                  class: _normalizeClass([material._id === _ctx.selected && "text-white"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(material.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]),
                                (_ctx.sanitize(material.description).length)
                                  ? (_openBlock(), _createBlock(_component_q_item_label, {
                                      key: 0,
                                      class: _normalizeClass([material._id === _ctx.selected && "text-white"]),
                                      caption: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.sanitize(material.description).substring(0, 80)) + _toDisplayString(_ctx.sanitize(material.description).length > 80 ? '...' : ''), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "class"])), [
                          [_directive_ripple]
                        ])
                      }), 256))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}